export default __webpack_public_path__ + "static/media/homepage_step_1.6c4a152c.svg";